import { createI18n } from 'vue-i18n';
import { setI18nInstance, enErrorMessages } from '@arbocollab/arbo-common-utils';

async function setupI18n() {
    const i18n = createI18n({
        legacy: false,
        locale: 'en',
        fallbackLocale: 'en',
        messages: {
            en: {
                errorMessages: enErrorMessages // Error Message Translation from @arbocollab/arbo-common-utils
            }
        }
    });

    return i18n;
}
export const setupErrorHelper = async () => {
    // Initialize and set the i18n instance
    const i18n = await setupI18n();
    setI18nInstance(i18n.global);
    return i18n;
};

export const dummyError = {
    code: 'E-0-GEN-2',
    error: {
        type: 'gen',
        key: 'data_locked'
    },
    details: [],
    message: '[E-0-GEN-2] Update failed. Record(s) are locked or currently being updated. You may try again later.'
};
